import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import { CalcularHspMedioOutput } from "./types";

class HspProvider extends AProvider {
    constructor() {
        super("/cadastros/hsp");
    }

    async calcular(latitude: number, longitude: number): Promise<CalcularHspMedioOutput> {
        const request: IDataRequest = { url: `${this.path}/calcular`, data: { latitude, longitude } }
        const response: IDataResponse<CalcularHspMedioOutput> = await api.post(request);
        if (response.statusCode === STATUS_CODE.OK) {
            return response.data
        }
        return { hsp_medio: 0 }
    }
}

export { HspProvider }